import { getOperationalMetricMeta } from '../../../constants/operationalMetricCatalog';

/**
 * @param {string} metricKey
 * @param {number} value
 */
export function formatScalarMetricValue(metricKey, value) {
    const { scalarFormat } = getOperationalMetricMeta(metricKey);
    const num = Number(value);
    const safe = Number.isFinite(num) ? num : 0;
    if (scalarFormat === 'percent') {
        const formatted = new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
        }).format(safe);
        return `${formatted}%`;
    }
    return new Intl.NumberFormat('pt-BR').format(safe);
}

/**
 * @param {{ value: number, currency?: string }} data
 */
export function formatMoneyMetricValue(data = {}) {
    const num = Number(data.value);
    const safe = Number.isFinite(num) ? num : 0;
    const currency = data.currency || 'BRL';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency,
    }).format(safe);
}
